export interface IconProps {
  url?: string;
  rounded?: boolean;
  classes?: { l1?: string; l2?: string; l3?: string };
}
export default function Icon(props: IconProps) {
  return (
    <div
      className={
        " min-w-[40px] rounded-full border border-slate-400 flex justify-center items-center " +
        (props.classes?.l1 || "w-10 h-10")
      }
    >
      <div
        className={
          `overflow-hidden ${props.rounded ? "rounded-full" : ""} ` + (props.classes?.l2 || "w-7 h-7")
        }
      >
        <img src={props.url} alt="" className={"w-full " + props.classes?.l3} />
      </div>
    </div>
  );
}
